import axios from 'axios';
import AuthenticationHelper from './authenticationHelper';
import uniq from 'uniquid';

const setAxiosConfiguration = () => {
  axios.defaults.baseURL = `${window.location.protocol}//${window.location.host}/api/`;
};

const setAxiosInterceptors = () => {
  axios.interceptors.request.use((config) => {
    config.headers = {
      Authorization: AuthenticationHelper.isJwtTokenStored() ? AuthenticationHelper.getJwtToken() : '',
      //TODO: Research and apply solution for webpack build (options: workaround)
      ['X-Request-Id']: uniq()
    };

    return config;
  });
};

export const initAxios = () => {
  setAxiosConfiguration();
  setAxiosInterceptors();
};



// WEBPACK FOOTER //
// ./src/shared/helpers/axiosHelper.js